import { differenceInDays, format, formatDistanceToNowStrict } from "date-fns";

/** Parse a date string as UTC (mirrors moment.utc().local() behavior). */
function parseAsUTC(dateString: string | Date): Date {
  if (dateString instanceof Date) return dateString;
  if (!dateString.endsWith("Z") && !dateString.includes("+")) {
    return new Date(dateString + "Z");
  }
  return new Date(dateString);
}

export function formatDate(dateString: string | Date, numberOnly = true, withHours = true): string {
  const date = parseAsUTC(dateString);
  if (numberOnly) {
    return withHours ? format(date, "yyyy-MM-dd - h:mm a") : format(date, "yyyy-MM-dd");
  }
  return withHours ? format(date, "MMM d, yyyy h:mm a") : format(date, "MMM d yyyy");
}

export function formatDateToISOStringWithMilisec(dateString: string | Date): string {
  return `${new Date(dateString).toISOString().replace("Z", "")}+00:00`;
}

export function formatShortAbsolute(date: Date): string {
  const now = new Date();
  const sameYear = date.getFullYear() === now.getFullYear();
  return sameYear ? format(date, "MMM d, h:mm a") : format(date, "MMM d, yy, h:mm a");
}

export function formatShortRelative(date: Date): string {
  const dayDiff = differenceInDays(new Date(), date);
  if (dayDiff >= 7 && dayDiff < 30) {
    return `${Math.floor(dayDiff / 7)}w`;
  }

  const duration = formatDistanceToNowStrict(date, { roundingMethod: "floor", addSuffix: false });
  return duration
    .replace(" seconds", "s")
    .replace(" second", "s")
    .replace(" minutes", "m")
    .replace(" minute", "m")
    .replace(" hours", "h")
    .replace(" hour", "h")
    .replace(" days", "d")
    .replace(" day", "d")
    .replace(" weeks", "w")
    .replace(" week", "w")
    .replace(" months", "mo")
    .replace(" month", "mo")
    .replace(" years", "y")
    .replace(" year", "y");
}

export function formatRelativeDate(date: Date | string): string {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  return formatDistanceToNowStrict(dateObj, { addSuffix: true });
}

export function formatShortDate(date: Date | string): string {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  const now = new Date();
  const sameYear = dateObj.getFullYear() === now.getFullYear();
  return sameYear ? format(dateObj, "MMM d") : format(dateObj, "MMM d, yyyy");
}
